import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';

import { supportTicketDetailSchema } from '@/_containers/support/shared/schemas/support-query-schema';

import { defaultValues } from './model';

export function useTicketDetailsFormDefinition() {
  return useForm({
    resolver: zodResolver(supportTicketDetailSchema),
    defaultValues,
  });
}
